__turbopack_context__.v({
  "Button": "index-module__XxFgDW__Button",
  "count": "index-module__XxFgDW__count",
  "suffix": "index-module__XxFgDW__suffix",
});
